export default "__VITE_ASSET__BDKPXGEC__"